import api from "../../../api/api";





const submitMessage = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/admin/simulator/chat",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}





const chatSimulatorServices = {
    submitMessage,
}
export default chatSimulatorServices;